import type { VerifyApiResponse } from "./types";

export class StampNotFoundError extends Error {
  constructor(public readonly stampId: string) {
    super("stamp not found");
    this.name = "StampNotFoundError";
  }
}

export class ApiUnreachableError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ApiUnreachableError";
  }
}

export async function fetchStampVerification(
  baseUrl: string,
  stampId: string,
): Promise<VerifyApiResponse> {
  const url = `${baseUrl.replace(/\/$/, "")}/v/${stampId}`;
  let resp: Response;
  try {
    resp = await fetch(url, { headers: { Accept: "application/json" } });
  } catch (e) {
    throw new ApiUnreachableError(`fetch failed: ${String(e)}`);
  }
  if (resp.status === 404) {
    throw new StampNotFoundError(stampId);
  }
  if (!resp.ok) {
    throw new ApiUnreachableError(`stamp-svc returned ${resp.status}`);
  }
  return (await resp.json()) as VerifyApiResponse;
}
